import React, { forwardRef, memo } from "react"
import { useTextWithBreaksContext } from "../index"
import { MainWrapper } from "../Components"
import Row from "../Static/Row"
import Reveal from "../../../../animations/Reveal"

const StaticTextWithBreaks = forwardRef(function StaticTextWithBreaks(
	{ parentId = "", className = "", left = false, imageLoadPriority = false, disableInView = false, disableAnimation = false, ...props },
	fref,
) {
	const rows = useTextWithBreaksContext("formatted")

	return (
		<MainWrapper ref={fref} className={`${className} text-with-breaks static`} left={left} {...props}>
			{rows.map((item, index) => {
				if (disableAnimation) {
					return (
						<Row key={index} data={item} parentId={parentId} imageLoadPriority={imageLoadPriority} index={index} left={left} />
					)
				}
				return (
					<Reveal key={index} onInView={!disableInView} startViewPort="70%">
						<Row data={item} parentId={parentId} imageLoadPriority={imageLoadPriority} index={index} left={left} />
					</Reveal>
				)
			})}
		</MainWrapper>
	)
})

export default memo(StaticTextWithBreaks)
